<script lang="ts">
	import { box, mergeProps } from "svelte-toolbelt";
	import { useCalendarCell } from "./calendar.svelte.js";
	import { useId } from "./internal/use-id.js";

	let {
		children,
		child,
		ref = $bindable(null),
		id = useId(),
		date,
		month,
		...restProps
	} = $props();

	const cellState = useCalendarCell({
		id: box.with(() => id),
		ref: box.with(
			() => ref,
			(v) => (ref = v)
		),
		date: box.with(() => date),
		month: box.with(() => month),
	});

	const mergedProps = $derived(mergeProps(restProps, cellState.props));
</script>

{#if child}
	{@render child({
		props: mergedProps,
		...cellState.snippetProps,
	})}
{:else}
	<td {...mergedProps}>
		{@render children?.(cellState.snippetProps)}
	</td>
{/if}

<style>
  td {
    /*padding-top: var(--calendar-day-padding);*/
  }
</style>
